var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgRotateBack = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 49,
    viewBox: "0 0 56 49",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 24.75C8.5 12.1855 18.6855 2 31.25 2C43.8145 2 54 12.1855 54 24.75C54 37.3145 43.8145 47.5 31.25 47.5C22.9744 47.5 15.7309 43.0814 11.75 36.4747",
    stroke: "#6BA543",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.25 18.25L8.5 24.75L2 15",
    stroke: "#6BA543",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRotateBack, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/rotate_back.dd046700.svg";
export { ForwardRef as ReactComponent };